<!--
 * @Author: your name
 * @Date: 2022-03-15 10:31:29
 * @LastEditTime: 2022-03-28 19:41:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\summary.vue
-->
<template>
  <div>
    <div class="all">
      <div class="protocol">
        <div class="text-header">
          <p>{{ $t("common.header") }}</p>
        </div>
        <div class="Technology">
          <p>{{ $t("Technology.consensusMean") }}</p>
        </div>
        <div class="introduce">
          {{ $t("common.introduce") }}
        </div>
        <div class="bottm">
          <div class="bottm-imgs">
            <span class="imgs">
              <img
                src="../../../assets/pc/intro/Group 2231@2x.png"
                alt=""
              />
            </span>
            <span class="span2">
              <div class="dian"></div>
              <div class="dian-right-text">
                <p class="p1">{{ $t("common.dian") }}</p>
                <p class="p2">
                  {{ $t("Wave.goalDetail") }}
                </p>
              </div>
            </span>
          </div>
          <div class="bottm-imgs active">
            <span class="imgs imgse">
              <img
                src="../../../assets/pc/intro/Group 2232@2x.png"
                alt=""
              />
            </span>
            <span class="span2">
              <div class="dian dian2"></div>
              <div class="dian-right-text">
                <p class="p1">{{ $t("Wave.alg") }}</p>
                <p class="p2">
                  {{ $t("Wave.algDetail") }}
                </p>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
div {
  box-sizing: border-box;
}
p {
  color: #000;
}
span {
  display: inline-block;
  // width: 848px;
}
.all {
  padding: 231px 0 370px 40px;
  background: url(../../../assets/pc/intro/back.png) no-repeat center / 100%
    100%;
    background-size: 100%;
  // background-position: 0 300px;
  .protocol {
    width: 1190px;
    margin: 0 auto;
    .text-header {
      margin-bottom: 45px;
      p {
        font-size: 80px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 103px;
        -webkit-background-clip: text;
      }
    }
    .Technology {
      font-size: 24px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #000000;
      line-height: 28px;
      -webkit-background-clip: text;
      margin-bottom: 22px;
    }
    .introduce {
      font-size: 18px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #61666b;
      line-height: 30px;
      -webkit-background-clip: text;
    }
    .bottm {
      width: 100%;
      height: 100%;
      margin-top: 90px;
      .bottm-imgs {
        margin-top: 60px;
        width: 1190px;
        height: 210px;
        border-radius: 30px;
        border: 3px solid #fff;
        box-shadow: 0px 0px 4px 4px rgba(50, 50, 50, 0.05);
        padding: 35px 26px 11px 55px;
        position: relative;
        background-color: #fbfbfb;
        box-sizing: border-box;
        .imgs {
          width: 140px;
          height: 140px;
          float: left;
          margin-right: 108px;
          text-align: center;
          // background-color: #000;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .span2{
          margin-top: 30px;
        }
        .imgse {
          margin-top: 41px;
          width: 140px;
          height: 140px;
          img {
            width:100%;
            height: 100%;
          }
        }
        .dian {
          width: 7px;
          height: 7px;
          border-radius: 2px;
          background: #4573e7;
          float: left;
          margin: 10px 12px 0 0;
        }
        .dian2 {
          background: #e74545;
        }
        .dian-right-text {
          float: left;
          width: 836px;
          .p1 {
            font-size: 18px;
            font-family: Poppins-SemiBold, Poppins;
            font-weight: 600;
            color: #2c1d1a;
            line-height: 31px;
            -webkit-background-clip: text;
          }
          .p2 {
            font-size: 14px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #737582;
            line-height: 24px;
            -webkit-background-clip: text;
          }
        }
      }
      .active {
        height: 275px;
      }
    }
  }
}
</style>
